"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledSubHeader = styled_components_1.default.div `
  align-items: center;
  color: ${config_1.colors.purpleText};
  display: flex;
  font: bold ${config_1.fontSizes.tiny} ${config_1.fontFamilies.primary};
  margin-bottom: 10px;
`;
